/* eslint-disable react/require-default-props */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

const aspectRatioClasses = {
  '1:1': 'sui-aspect-square',
  '3:2': 'sui-aspect-[3/2]'
};

const BundleImage = ({
  src, alt, aspectRatio = '1:1'
}) => {

  const aspectRatioClass = aspectRatioClasses[aspectRatio] || '';
  return (
    <img
      data-testid="bundle-image"
      className={`sui-block sui-object-contain ${aspectRatioClass} md:sui-h-full sui-m-0`}
      src={src}
      alt={alt}
      width="100%"
      height="100%"
    />
  );
};

BundleImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  aspectRatio: PropTypes.string
};

export { BundleImage };